<template>
	<div class="work-order">
		<filter-panel :data="groups" @search="filterChange"></filter-panel>
		<data-list
			:data="data"
			:columns="column"
			:loading="loading"
			:page="page"
			:table-style="{ name: 'mixture' }"
			:page-size="page.pageSize"
			@page-size-changed="pageSizeChanged"
			@page-changed="pageChanged"
			@sort-change="sortChange"
		></data-list>
	</div>
</template>

<script>
import filterPanel from '@/components/iglobalwin/filterPanelNew/filterPanel.vue';
import api from '@/backend/apiConfig/apiConfig';
import listPageCreate from '@/mixins/listPageCreate';
import customer from '@/mixins/customer';
import { handleType, workOrderType } from '@/common/dictionary';
import { mapGetters } from 'vuex';
import beforeRouteEnter from '@/mixins/beforeRouteEnter.js';
const list = listPageCreate({
	searchConfig: {
		api: api.workorder.workorderpage,
		method: 'POST',
	},
	getQuery(obj) {
		return _.assign(obj, { listType: 2 });
	},
});

export default {
	name: 'workOrderAll',
	components: { filterPanel },
	mixins: [list, customer, beforeRouteEnter],
	data() {
		let that = this;
		const column = [
			{
				label: '工单编号',
				type: 'custInfo',
				main: 'workOrderCode',
				event(row) {
					that.$router.push({
						name: 'workOrderAllDetail',
						query: {
							id: row.workOrderId,
						},
					});
				},
			},
			{
				label: '关联客户',
				type: 'custInfo',
				text: [
					{
						bind: 'customerName',
					},
				],
				minWidth: 100,
			},
			{
				label: '工单类型',
				bind: 'workOrderTypeStr',
			},
			{
				label: '问题类型',
				bind: 'problemTypeStr',
			},
			{
				label: '提交人',
				bind: 'createrName',
			},
			{
				label: '当前处理人',
				bind: 'handleName',
			},
			{
				label: '提交时间',
				type: 'custInfo',
				getClass(row) {
					if (row.isRead === 1) {
						return 'danger';
					}
				},
				text: [
					{
						disabled: true,
						bind: 'createTimeStr',
					},
				],
				sort: 'createTimeStr',
				options: [
					{
						label: '由低到高',
						value: 'asc',
					},
					{
						label: '由高到低',
						value: 'desc',
					},
				],
			},
			{
				label: '完成时间',
				type: 'custInfo',
				text: [
					{
						bind: 'handleTime',
						custValue: row => {
							if (row.handleType === 2) return row.handleTime;
							return '';
						},
					},
				],
			},
			{
				label: '当前处理时间',
				bind: 'intervalTime',
				getClass(row) {
					if (row.isRead === 1) {
						return 'danger';
					}
				},
			},
			{
				label: '当前状态',
				bind: 'handleTypeStr',
				getClass(row) {
					if (row.handleType === 0) {
						return 'warning';
					}
					if (row.handleType === 1) {
						return 'danger';
					}
					if (row.handleType === 2) {
						return 'normalText';
					}
					if (row.handleType === 3) {
						return 'deathText';
					}
					if (row.handleType === 4) {
						return 'deathText';
					}
				},
			},
			{
				label: '备注',
				type: 'custInfo',
				text: [
					{
						bind: 'remarks',
					},
				],
			},
		];
		return {
			column: column,
			customerName: '',
			customerId: '',
			imageFileName: [],
			notes: '',
			formData: {},
			defaultKey: null,
			workOrderType: '',
			workOrderCode: '',
			groups: {
				others: [
					{
						tagName: 'sky-input',
						placeholder: '工单编号',
						label: '工单编号',
						prop: 'workOrderCode',
						value: '',
					},
					{
						label: '提交时间段',
						startPlaceholder: '提交开始日期',
						endPlaceholder: '提交结束日期',
						prop: ['beginTimeStr', 'endTimeStr'],
						tagName: 'sky-date-picker',
						type: 'daterange',
						value: [],
					},
					{
						label: '完成时间段',
						startPlaceholder: '完成开始日期',
						endPlaceholder: '完成结束日期',
						prop: ['handleStartTimeStr', 'handleEndTimeStr'],
						tagName: 'sky-date-picker',
						type: 'daterange',
						value: [],
					},
				],
				multiples: [
					{
						defaultText: '工单类型',
						placeholder: '工单类型',
						label: '工单类型名称',
						prop: 'workOrderType',
						options: workOrderType,
						value: '',
					},
					{
						defaultText: '任务状态',
						placeholder: '任务状态',
						label: '任务状态',
						options: handleType,
						prop: 'handleType',
						multiple: true,
						value: [],
					},
				],
			},
		};
	},
	computed: {
		...mapGetters(['userId']),
	},
	methods: {
		formatUrls(list) {
			return list;
		},
	},
};
</script>

<style></style>
